import scan from '../util/elements/scan'
import vibrate from '../util/elements/vibrate'
import on from '../util/elements/on'
import destroys from '../util/elements/destroys'

export default function widgetQRReader (Site, $) {
  Site.widget(
    'qr-reader',
    {
      async _create () {
        destroys(this)

        this.transitionIn = (function () {
          let r
          const prom = new Promise(resolve => { r = resolve })
          prom.resolve = r
          return prom
        })()

        this.resultEl = $('[data-qr-result]')

        this.modal = {
          el: $(`<div class="qr-modal hidden"></div>`),
          close: $(`<div class="close-modal"></div>`),
          inner: $(`<div class="inner"></div>`),
          closeModal: () => {
            this.modal.el.addClass('hidden')
          },
          openModal: () => {
            this.modal.el.removeClass('hidden')
          }
        }

        this.modal.el.append(this.modal.close)
        this.modal.el.append(this.modal.inner)

        this.button = $(`
          <button class="button">Scan now</button>
        `)

        this.content = $(`<div class="qr-content"></div>`)

        this.element.append(this.button)
        this.element.append(this.content)
        this.element.append(this.modal.el)

        const onClick = on(
          this.button,
          'click',
          async e => {
            this.button.text('Scan again')
            this.modal.openModal()
            this.result = await scan(this.modal.inner)

            this.destroys(() => { if (this.result.cancel) this.result.cancel() })

            const code = await this.result

            if (code) {
              vibrate(1, 300)

              this.content.empty()
              this.content.append(
                `
                <h4 class="copy copy--intro-text">Found Order #${code}</h4>
                <a class="button button--inline-block" target="_blank" href="/wp-admin/post.php?post=${code}&action=edit">
                View Order #${code}
                </a>
                `
              )
              this.modal.closeModal()
            }
          }
        )

        const onStop = on(
          this.modal.close,
          'click',
          e => {
            if (this.result && this.result.cancel) {
              this.result.cancel()
            }
            this.modal.closeModal()
          }
        )

        this.destroys(
          onClick,
          onStop
        )
      }
    }
  )
}
